import React, { useEffect } from 'react';
import useSiteState from '@app/state/SiteState';
import { Navigate, Outlet } from 'react-router-dom';
import RegistrationState from '@app/model/authentication/RegistrationState';
import { UpscopeProvider } from '@upscopeio/react';
import { useMixpanel } from '@app/site/mixpanel/useMixpanel';
import { setSentryUser } from '@util/SentryHelper';

const UPSCOPE_ID = 'kMmzCXS9EX';

const ProtectedRoute: React.FunctionComponent<any> = ({ redirectPath = '/sign-in' }) => {
	const {
		principal,
		setAfterLoginPath,
	} = useSiteState(state => ({
		setExpirationDate: state.setExpirationDate,
		principal: state.principal,
		expirationDate: state.expirationDate,
		setAfterLoginPath: state.setAfterLoginPath,
	}));

	const mixpanel = useMixpanel();

	useEffect(() => {
		if (principal) {
			setSentryUser({ id: String(principal.id), username: principal.username });
			mixpanel?.identify(principal.username);
		}
	}, [principal]);


	if (!!principal && principal.registrationState === RegistrationState.COMPLETED) {
		return <UpscopeProvider apiKey={UPSCOPE_ID} enabled uniqueId={principal.username}>
			<Outlet />
		</UpscopeProvider>;
	}
	return <Navigate to={redirectPath} replace />;

};

export default ProtectedRoute;
